export default "__VITE_ASSET__DxZqfbQx__"